import Component from './sidebar';
export default Component;
